import { useMutation } from '@tanstack/react-query';

import type { BookingEventMutationResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useDeleteBookingEventWaveMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<BookingEventMutationResponse>({
        method: 'DELETE',
        url,
      }),
  });

export const useReorderBookingEventWavesMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; ids: number[] }) =>
      HttpClient.request<BookingEventMutationResponse>({
        method: 'PUT',
        url: `${params.url}/reorder`,
        data: { ids: params.ids },
      }),
  });
